export interface BrandConfig {
  app: {
    name: string
    title: string
    description: string
  }
  logo: {
    src?: string
    alt?: string
    favicon?: string
  }
  seo: {
    ogImage?: string
    twitterImage?: string
  }
  user: {
    name: string
    email: string
    username: string
    avatar: {
      src: string
      alt: string
    }
  }
  teams?: Array<{
    label: string
    avatar: {
      src: string
      alt: string
    }
  }>
}

export const brandConfig: BrandConfig = {
  app: {
    name: 'ANO RAG',
    title: 'ANO RAG Frontend',
    description: 'Admin interface for ANO RAG system',
  },
  logo: {
    favicon: '/favicon.ico',
  },
  seo: {},
  user: {
    name: 'User',
    email: 'user@example.com',
    username: 'user',
    avatar: {
      src: '',
      alt: 'User',
    },
  },
  teams: [],
}
